import { CategoryLink } from '../categories/CategoryLink'
import { TagLink } from '../tags/TagLink'
import { Category } from '@wellesley/openapi'

type CategoryAndTagsLinksProps = {
  category?: Category
  tags: string[]
}

const CategoryAndTagsLinks = ({
  category,
  tags,
}: CategoryAndTagsLinksProps) => (
  <div className="gap-s flex flex-row flex-wrap items-center">
    {category && <CategoryLink category={category} />}
    <span>
      {tags.map((tag, index) => (
        <span key={tag}>
          <TagLink tag={tag} />
          {index < tags.length - 1 && ', '}
        </span>
      ))}
    </span>
  </div>
)

export { CategoryAndTagsLinks }
